require("./bootstrap");
require("./jquery.bundle");
require("./plugins.bundle");
require("./core");
require("./datatables.bundle");
require('select2');
require('select2/dist/js/i18n/pt-BR');
